import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  buttonsStyle,
  dateFormatter,
} from "../../../components/tables/table";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import { changeStatusTag, deleteTag, getTags } from "../../../../api/tag";
import FiltersCard from "../../../components/filters/Filter";
import {
  Button,
  CircularProgress,
  FormControlLabel,
  InputLabel,
  makeStyles,
  Switch,
  TextField,
  Tooltip,
} from "@material-ui/core";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import DeleteIcon from "@material-ui/icons/Delete";
import { Autocomplete } from "@material-ui/lab";
import {
  Edit,
  WebAsset,
  WebAssetOutlined,
  WebAssetRounded,
  WebAssetTwoTone,
} from "@material-ui/icons";
import { shallowEqual, useSelector } from "react-redux";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { getNonEmpty } from "../../../../utils/helpers";

function getData(tags) {
  let data = [];
  for (let i = 0; i < tags.length; ++i) {
    const elem = {};
    elem.nombre = getNonEmpty(tags[i]?.name);
    elem.active = tags[i]?.active;
    elem.web = tags[i]?.web;
    elem.createdAt = tags[i]?.createdAt;
    elem.id = tags[i]?._id;
    data = data.concat(elem);
  }
  return data;
}

const useStyles = makeStyles(() => ({
  dialogContent: {
    padding: 0,
    overflow: "hidden",
  },
  fancyLoader: {
    color: "#AF9A51 ",
    animation: `$spin 1s linear infinite`,
  },
  "@keyframes spin": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));

export default function TagsPage() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tag, setTag] = useState({});
  const [tagId, setTagId] = useState("");
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const history = useHistory();
  const classes = useStyles();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  const columns = [
    { dataField: "nombre", text: "Nombre", sort: true },
    { dataField: "createdAt", text: "Fecha", formatter: dateFormatter },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  function buttonFormatter(cell) {
    const elem = data.find((item) => item._id === cell);
    return (
      <>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-tag/" + cell)}
          >
            <Edit />
          </Button>
        </Tooltip>
        {user?.role === "admin" && (
          <>
            <Tooltip title={elem?.active ? "Disable" : "Enable"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setTag(elem);
                  setOpenConfirmDialog(1);
                }}
              >
                {elem?.active ? (
                  <ToggleOffIcon />
                ) : (
                  <ToggleOnIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setTag(elem);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  useEffect(() => {
    setLoading(true);
    getTags()
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setFilteredData(res.data);
          setLoading(false);
          setRefresh(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        alertError({
          error: error,
          customMessage: "Could not get tags.",
        });
      });
  }, [refresh]);

  return (
    <>
      <Card>
        <CardHeader title="Lista Tags">
          <CardHeaderToolbar>
            <Button
              type="button"
              className="btn btn-primary"
              onClick={() => history.push("/edit-tag")}
            >
              Add
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table data={getData(filteredData)} columns={columns} />
          <ConfirmDialog
            title={`Are you sure you want to ${
              tag?.active ? "disable" : "enable"
            } this brand?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusTag(tag?._id, !tag?.active)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${tag?.active ? "Disabled!" : "Enabled!"}`,
                      customMessage: `Brand ${
                        tag?.active ? "disabled" : "enabled"
                      } successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${
                      tag?.active ? "disable" : "enable"
                    } brand.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={"Are you sure you want to remove this brand?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteTag(tag?._id)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "Brand removed successfully.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not remove brand.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
